import UserApi from "./../api/userApi";

export const GET_USER_INFO = "user/GET_USER_INFO";
export const GET_USER_INFO_REQUESTED = "user/GET_USER_INFO_REQUESTED";
export const GET_USER_INFO_REQUEST_ERROR = "user/GET_USER_INFO_REQUEST_ERROR";

const initialState = {
  isLoading: false,
  hasData: false,
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_INFO_REQUESTED:
      return {
        isLoading: true,
        ...state
      };
    case GET_USER_INFO:
      return {
        isLoading: false,
        hasData: true,
        data: action.data
      };
    case GET_USER_INFO_REQUEST_ERROR:
      return {
        isLoading: false,
        ...state
      };
    default:
      return state;
  }
};

export const getUserInfo = () => {
  return dispatch => {
    dispatch({ type: GET_USER_INFO_REQUESTED });
    if (process.env.NODE_ENV === "development") {
      return UserApi.getUserInfoFake()
        .then(data => {
          dispatch({
            type: GET_USER_INFO,
            data
          });
        })
        .catch(err => {
          dispatch({
            type: GET_USER_INFO_REQUEST_ERROR
          });
        });
    } else {
      return UserApi.getUserInfo()
        .then(data => {
          dispatch({
            type: GET_USER_INFO,
            data
          });
        })
        .catch(err => {
          dispatch({
            type: GET_USER_INFO_REQUEST_ERROR
          });
        });
    }
  };
};



// WEBPACK FOOTER //
// ./src/modules/user.js